//Importación de componentes
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './Home.module.css';
import styled, { keyframes, css } from 'styled-components';

//Importación de secciones
import Seccion1 from './Seccion1/S1';
import Seccion2 from './Seccion2/S2';
import ContactSection from './Seccion5/S5';
import Productos from './Productos/Productos';
import FAQ from './FAQ/FAQ';
import Footer from './Footer/Footer';
import Agendar from './Agendar/Agendar';

//Importación de pantalla de carga
import Loading from './Loading/Loading';

// Animación para el desplazamiento en la carga
const slideAway = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
`;

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  ${props => props.isFinished && css`
    animation: ${slideAway} 0.5s ease-in-out forwards;
  `}
`;

function Home() {
  const [isLoading, setIsLoading] = useState(true);
  const [isFinished, setIsFinished] = useState(false);
  const buttonContentRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  const [isButtonVisible, setIsButtonVisible] = useState(true);
  const location = useLocation();

  const handleMouseOver = () => {
    setIsHovered(true);
  };

  const handleMouseOut = () => {
    setIsHovered(false);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1)); // Remueve el '#' del hash
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      // Calculate the scroll position where the last two sections start
      const lastTwoSectionsStart = documentHeight - (windowHeight * 2);
      
      if (scrollTop > lastTwoSectionsStart) {
        setIsButtonVisible(false);
      } else {
        setIsButtonVisible(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const minLoadingTime = 3000;
    const startTime = Date.now();
    /*Bloquear scroll para paginas e interfaz de celular tambien*/
    document.body.style.overflow = 'hidden';
    const timer = setTimeout(() => {
      const elapsedTime = Date.now() - startTime;
      if (elapsedTime < minLoadingTime) {
        setTimeout(() => {
          setIsFinished(true);
          setTimeout(() => setIsLoading(false), 1000);
          /*Desbloquear scroll para paginas e interfaz de celular tambien*/
          document.body.style.overflow = 'visible';
        }, minLoadingTime - elapsedTime);
      } else {
        setIsFinished(true);
        setTimeout(() => setIsLoading(false), 1000);
        /*Desbloquear scroll para paginas e interfaz de celular tambien*/
        document.body.style.overflow = 'visible';
      }
    }, minLoadingTime);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  const navigate = useNavigate();
  //bloquear el scroll horizontal
  useEffect(() => {
    document.body.style.overflowX = 'hidden';
  }, []);
  return (
    <div id='home' className={styles.home}>
      {isLoading && (
        <LoadingContainer isFinished={isFinished}>
          <Loading/>
        </LoadingContainer>
      )}
      <Seccion1 />
      <Productos />
      <Seccion2 />
      <ContactSection/>
      <FAQ />
      <Agendar />
      <Footer />
      <div className={`${styles.scheduleButtonFixed} ${!isButtonVisible ? styles.hidden : ''}`}>
        
        <button 
          className={`${styles.neonButton} ${isHovered ? styles.heartbeat : ''}`} 
          onMouseOver={handleMouseOver} 
          onMouseOut={handleMouseOut} 
          ref={buttonContentRef}
          onClick={() => navigate('/contacto')}
        >
          <span className={styles.diseño}></span>
          <span className={styles.diseño}></span>
          <span className={styles.diseño}></span>
          <span className={styles.diseño}></span>
          <span className={styles.letter}>A</span>
          <span className={styles.letter}>g</span>
          <span className={styles.letter}>e</span>
          <span className={styles.letter}>n</span>
          <span className={styles.letter}>d</span>
          <span className={styles.letter}>a</span>
          <span className={styles.letter}>r</span>
          <span className={styles.space}> </span>
          <span className={styles.letter}>c</span>
          <span className={styles.letter}>i</span>
          <span className={styles.letter}>t</span>
          <span className={styles.letter}>a</span>
        </button>
        
      </div>
    </div>
  );
}

export default Home;